module.exports = __webpack_public_path__ + "img/collect-icon-audio.3d6fed26.svg";